import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewColorPelaje = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'color_pelaje',
        name: 'Color Pelaje',
        component: ViewColorPelaje,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
